<template>
  <div class="search-bar f--c">
    <i class="iconfont icon-a-search-line1" />
    <el-input v-model="text" :placeholder="$t('Components.Mobile.SearchBar.SearchingFor')" enterkeyhint="search" @keyup.enter.native="search(text)"></el-input>
    <photograph>
      <i class="iconfont icon-photo"></i>
    </photograph>
  </div>
</template>

<script>
import Photograph from '../../views/index/components/Photograph.vue'
export default {
  components: { Photograph },
  data() {
    return {
      visible: false,
      text: ''
    }
  },
  created() {
    this.text = this.$route.query.search
  },
  mounted() {
  },
  methods: {
    setSearches(text) {
      this.text = text
    },
    search(text) {
      this.text = text
      this.$emit('search', text)
    },
    clear() {
      this.text = ''
      this.$emit('search', '')
    },
    handleFocus() {
      if (this.$route.path.indexOf('/product-list') > -1) return
      this.$router.push('/mall/search')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  width: 100%;
  height: .8rem;
  border-radius: .8rem;
  border: .5px solid #CDD4DD;
  padding: 0 .4rem;

  /deep/ .el-input--medium .el-input__inner {
    width: 100%;
    border: unset;
    background-color: unset;
    padding: 0 .16rem;
  }

  .icon-a-search-line1 {
    color: #7B7B7B;
    font-size: .32rem;
  }

  .icon-photo {
    color: #747A87;
    font-size: .32rem;
  }
}
</style>
